import { KeyboardBackspace as Arrow } from '@mui/icons-material';
import { Link } from '@on3/ui-lib/components/Link';

import styles from './TeamsButton.module.scss';

export const TeamsButton = () => {
  return (
    <Link className={styles.component} data-ui="teams-button" href="/teams/">
      Find your team
      <Arrow />
    </Link>
  );
};
